import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FaBalanceScale,
  FaGlobeAfrica,
  FaShieldAlt,
  FaArrowRight,
} from 'react-icons/fa';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ataaLogo from '../assets/LOGO1.png';
import ricsLogo from '../assets/1732801313133.jpeg';
import './NosStandards.css';

const NosStandards = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Nos Standards : RICS, IVS & Charte Marocaine | ATAA REALTY"
        description="ATAA REALTY conduit ses missions en alignement avec les standards RICS, les International Valuation Standards (IVS) et la Charte marocaine de l'expertise immobilière."
        canonical="https://ataarealty.com/nos-standards"
        keywords="RICS Maroc, IVS, International Valuation Standards, charte marocaine expertise immobilière, standards expertise immobilière, MRICS, expertise conforme RICS"
      />
      <Navbar />

      {/* HERO */}
      <header className="standards-header">
        <div className="standards-overlay"></div>
        <div className="container standards-title-box anim-up">
          <span className="standards-subtitle">Référentiels &amp; Engagements</span>
          <h1>Nos Standards</h1>
        </div>
      </header>

      {/* INTRO */}
      <section className="standards-intro-section">
        <div className="container">
          <div className="standards-intro-grid">
            <div className="standards-intro-text anim-up delay-1">
              <span className="intro-eyebrow">UNE EXIGENCE DE TRAVAIL</span>
              <h2>
                Aligner chaque mission aux meilleurs <span className="highlight">référentiels professionnels</span>
              </h2>
            </div>
            <div className="standards-intro-body anim-up delay-2">
              <p>
                <strong>ATAA REALTY</strong> inscrit ses interventions dans le
                respect des standards internationaux de l'expertise et du conseil
                immobilier, notamment ceux portés par la{' '}
                <strong>Royal Institution of Chartered Surveyors (RICS)</strong>{' '}
                et les <strong>International Valuation Standards (IVS)</strong>,
                auxquels le cabinet aligne ses méthodologies d'analyse,
                d'évaluation et de restitution.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TROIS PILIERS */}
      <section className="standards-pillars-section">
        <div className="container">
          <div className="standards-pillars-grid">
            <div className="standards-pillar anim-up delay-1">
              <div className="pillar-icon"><FaShieldAlt /></div>
              <span className="pillar-eyebrow">Standard International</span>
              <h3>RICS</h3>
              <p>
                Royal Institution of Chartered Surveyors — référentiel mondial
                de l'expertise immobilière, encadrant la déontologie, la
                méthodologie et la qualité des prestations.
              </p>
            </div>

            <div className="standards-pillar anim-up delay-2">
              <div className="pillar-icon"><FaGlobeAfrica /></div>
              <span className="pillar-eyebrow">Référentiel d'évaluation</span>
              <h3>IVS</h3>
              <p>
                International Valuation Standards — socle international des
                bonnes pratiques d'évaluation, compatible avec les exigences de
                présentation financière (IFRS).
              </p>
            </div>

            <div className="standards-pillar anim-up delay-3">
              <div className="pillar-icon"><FaBalanceScale /></div>
              <span className="pillar-eyebrow">Cadre National</span>
              <h3>Charte Marocaine</h3>
              <p>
                Charte marocaine de l'expertise immobilière — socle de référence
                pour la rigueur, l'éthique et la qualité des prestations sur le
                marché immobilier marocain.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* DEMARCHE */}
      <section className="standards-content-section">
        <div className="container">
          <div className="standards-grid">
            <div className="standards-text-col">
              <h2 className="anim-up delay-1">Notre Engagement</h2>

              <p className="anim-up delay-1">
                Cette démarche s'inscrit dans le cadre des pratiques
                professionnelles nationales, à travers la{' '}
                <strong>Charte marocaine de l'expertise immobilière</strong>,
                conçue comme un socle de référence pour la rigueur, l'éthique
                et la qualité des prestations sur le marché marocain.
              </p>

              <p className="anim-up delay-2">
                Dans cette continuité, la direction du cabinet a pris part à
                l'élaboration de la <strong>nouvelle version</strong> de cette
                charte, traduisant un engagement actif en faveur de la
                structuration de la profession, de la transmission des bonnes
                pratiques et du rapprochement entre référentiels internationaux
                et cadre national.
              </p>

              <div className="highlight-box anim-up delay-3">
                <p>
                  Ces référentiels constituent pour <strong>ATAA REALTY</strong>{' '}
                  non pas un argument, mais une <em>exigence de travail</em>,
                  guidant chaque mission dans une logique de responsabilité, de
                  méthode et de valeur durable.
                </p>
              </div>

              <div className="standards-logos anim-up delay-3">
                <img
                  src={ataaLogo}
                  alt="ATAA REALTY"
                  className="standards-logo"
                />
                <img
                  src={ricsLogo}
                  alt="RICS"
                  className="standards-logo"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="standards-cta-section">
        <div className="container">
          <h3>Une mission à conduire selon ces standards ?</h3>
          <p>
            Échangeons sur votre projet et structurons ensemble une intervention
            alignée aux meilleures pratiques internationales et nationales.
          </p>
          <Link to="/contact" className="standards-cta-btn">
            Nous Contacter <FaArrowRight />
          </Link>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default NosStandards;
